import React from 'react';
import { useSelector } from 'react-redux';
import { Skeleton } from 'antd';
import { RootState } from '../../redux/store';
import { StatsGrid, StatsCard, StatsIconContainer, StyledStatistic, StatHelpText, SkeletonCard } from './styles';
import { LABELS, STATS } from './constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLaptop, faCog, faPlus } from '@fortawesome/free-solid-svg-icons';
import { ThemeProvider } from 'styled-components';
import { StatsCardsProps } from './types';

export const StatsCards: React.FC<StatsCardsProps> = ({ totalCount, filteredCount, loading = false }) => {
  const { theme } = useSelector((state: RootState) => state.theme);
  const themeMode = theme === 'dark' ? 'dark' : 'light';

  if (loading) {
    return (
      <ThemeProvider theme={{ mode: themeMode }}>
        <StatsGrid>
          {[1, 2, 3].map((index) => (
            <SkeletonCard key={index}>
              <Skeleton active>
                <Skeleton.Avatar size={48} shape="circle" style={{ marginBottom: 16 }} />
                <Skeleton.Input active size="small" style={{ width: '60%', marginBottom: 8 }} />
                <Skeleton.Input active size="large" style={{ width: '40%', marginBottom: 8 }} />
                <Skeleton.Input active size="small" style={{ width: '70%' }} />
              </Skeleton>
            </SkeletonCard>
          ))}
        </StatsGrid>
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider theme={{ mode: themeMode }}>
      <StatsGrid>
        <StatsCard>
          <StatsIconContainer bgColor="#14b8a6">
            <FontAwesomeIcon icon={faLaptop} size="lg" color="white" />
          </StatsIconContainer>
          <StyledStatistic
            title={LABELS.TOTAL_DEVICE_TYPES}
            value={totalCount}
            valueStyle={{ color: themeMode === 'dark' ? '#ffffff' : '#262626' }}
          />
          <StatHelpText color="#14b8a6">
            {STATS.AVAILABLE_CONFIGURATIONS}
          </StatHelpText>
        </StatsCard>

        <StatsCard>
          <StatsIconContainer bgColor="#10b981">
            <FontAwesomeIcon icon={faCog} size="lg" color="white" />
          </StatsIconContainer>
          <StyledStatistic
            title={LABELS.ACTIVE_TYPES}
            value={filteredCount}
            valueStyle={{ color: themeMode === 'dark' ? '#ffffff' : '#262626' }}
          />
          <StatHelpText color="#10b981">
            {STATS.CURRENTLY_AVAILABLE}
          </StatHelpText>
        </StatsCard>

        <StatsCard>
          <StatsIconContainer bgColor="#f59e0b">
            <FontAwesomeIcon icon={faPlus} size="lg" color="white" />
          </StatsIconContainer>
          <StyledStatistic
            title={LABELS.ADD_NEW_TYPE}
            value="+"
            valueStyle={{ color: themeMode === 'dark' ? '#ffffff' : '#262626' }}
          />
          <StatHelpText color="#f59e0b">
            {STATS.CREATE_CONFIGURATION}
          </StatHelpText>
        </StatsCard>
      </StatsGrid>
    </ThemeProvider>
  );
};
